"use client";

import {
  IconBrandMastercard,
  IconBrandPaypal,
  IconBrandStripe,
  IconBrandVisa,
  IconCreditCard,
} from "@tabler/icons-react";
import { cn } from "@/lib/utils";

type BillingPaymentMethodBrandIconProps = {
  brand?: string | null;
  className?: string;
};

export const BillingPaymentMethodBrandIcon = ({ brand, className }: BillingPaymentMethodBrandIconProps) => {
  const normalized = (brand ?? "").toLowerCase().trim();
  const combined = cn("size-6 shrink-0", className);

  switch (normalized) {
    case "visa":
      return <IconBrandVisa className={combined} aria-hidden />;
    case "mastercard":
      return <IconBrandMastercard className={combined} aria-hidden />;
    case "paypal":
      return <IconBrandPaypal className={combined} aria-hidden />;
    case "stripe":
    case "link":
      return <IconBrandStripe className={combined} aria-hidden />;
    default:
      return <IconCreditCard className={cn(combined, "stroke-[1.5]")} aria-hidden />;
  }
};
